/**
 * @coeldery/bottom-nav —— 內置 SVG icon 集（**社群／會員類**）
 *
 * 顏色一律 `var(--color-primary)`（active）／`var(--color-text-secondary)`（inactive）——
 * **唔准 hardcode hex**。28px 顯示（viewBox 24）。
 */
export type NavIcon = 'benefits' | 'news' | 'card' | 'ads' | 'setting' | 'home' | 'me';

const col = (active: boolean): string =>
  active ? 'var(--color-primary)' : 'var(--color-text-secondary)';

function Frame({ children }: { children: React.ReactNode }) {
  return (
    <svg width="26" height="26" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      {children}
    </svg>
  );
}

export function NavIconSvg({ name, active }: { name: NavIcon; active: boolean }) {
  const c = col(active);
  switch (name) {
    case 'benefits': // 禮物（優惠／福利）
      return (
        <Frame>
          <rect x="3" y="8" width="18" height="13" rx="2" stroke={c} strokeWidth="2" />
          <path d="M3 12h18M12 8v13" stroke={c} strokeWidth="2" />
          <path
            d="M12 8s-1.1-4-3.5-4C7 4 6.4 5.1 6.4 6c0 1.2 1 2 2.3 2H12zm0 0s1.1-4 3.5-4C17 4 17.6 5.1 17.6 6c0 1.2-1 2-2.3 2H12z"
            stroke={c}
            strokeWidth="2"
            strokeLinejoin="round"
          />
        </Frame>
      );
    case 'news': // 報紙
      return (
        <Frame>
          <rect x="3" y="5" width="18" height="14" rx="2" stroke={c} strokeWidth="2" />
          <path d="M7 9h6M7 13h6M16 9h1.5M16 13h1.5" stroke={c} strokeWidth="2" strokeLinecap="round" />
        </Frame>
      );
    case 'card': // 會員卡
      return (
        <Frame>
          <rect x="2.5" y="5" width="19" height="14" rx="2.4" stroke={c} strokeWidth="2" />
          <path d="M2.5 9.5h19" stroke={c} strokeWidth="2" />
          <path d="M6 14.5h4" stroke={c} strokeWidth="2" strokeLinecap="round" />
        </Frame>
      );
    case 'ads': // 擴音器（廣告）
      return (
        <Frame>
          <path d="M4 10v4h3l7 4V6l-7 4H4z" stroke={c} strokeWidth="2" strokeLinejoin="round" />
          <path d="M17 9.5a3.5 3.5 0 010 5" stroke={c} strokeWidth="2" strokeLinecap="round" />
        </Frame>
      );
    case 'setting': // 齒輪（設定）
      return (
        <Frame>
          <circle cx="12" cy="12" r="3.2" stroke={c} strokeWidth="2" />
          <path
            d="M12 2v3M12 19v3M2 12h3M19 12h3M4.9 4.9l2.1 2.1M17 17l2.1 2.1M19.1 4.9L17 7M7 17l-2.1 2.1"
            stroke={c}
            strokeWidth="2"
            strokeLinecap="round"
          />
        </Frame>
      );
    case 'home':
      return (
        <Frame>
          <path d="M12 3.5l8 6.5v9.5H4V10l8-6.5z" stroke={c} strokeWidth="2" strokeLinejoin="round" />
          <path d="M10 19.5v-5h4v5" stroke={c} strokeWidth="2" strokeLinejoin="round" />
        </Frame>
      );
    case 'me':
      return (
        <Frame>
          <circle cx="12" cy="8" r="3.4" fill={c} />
          <path d="M4.5 20c0-3.6 3.4-6.4 7.5-6.4s7.5 2.8 7.5 6.4" stroke={c} strokeWidth="2" strokeLinecap="round" />
        </Frame>
      );
  }
}
